package uk.co.nickthecoder.glok.scene

import uk.co.nickthecoder.glok.backend.backend

/**
 * A thin border, which is always 1 logical pixel (ignoring the size passed to it).
 *
 * Used by Tantalum (the default theme) when the high-contrast is enabled.
 * Menu items, buttons etc. are given a ThinBorder, with a borderSize of 3,
 * therefore they normally have 2 pixels of extra padding, but when they are focused/armed/hovered-over,
 * the ThinBorder is replaced by a PlainBorder, and therefore the border takes the full 3 pixels.
 * If we had only used a PlainBorder, and adjusted the borderSize, then items would resize,
 * This would be confusing/distracting.
 */
object ThinBorder : Border {

    override fun draw(x: Float, y: Float, width: Float, height: Float, color: Color, size: Edges) {
        if (color.alpha != 0f) {
            backend.strokeInsideRect( x, y, x + width, y + height, 1f, color)
        }
    }

    override fun toString() = "ThinBorder"

}
